import axios from "axios";
import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import classes from "./CareerForm.module.css";
import { mouseContext } from "../../context/mouseContext";

const yearArr = Array.from({ length: 21 }, (_, i) => 2010 + i);

const CareerForm = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);
  const { domain } = useParams();

  const [candidateInfo, setCandidateInfo] = useState({
    fullname: "",
    email: "",
    mobilenumber: "",
    college: "",
    passout: "",
    address: "",
    github: "",
    linkedin: "",
  });

  const [cv, setCV] = useState(null);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFieldChange = (e) => {
    setCandidateInfo((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validateForm = () => {
    if (
      !candidateInfo.fullname ||
      !candidateInfo.email ||
      !candidateInfo.mobilenumber ||
      !candidateInfo.college ||
      !candidateInfo.passout ||
      !candidateInfo.address ||
      !cv
    ) {
      return "All required fields must be filled.";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(candidateInfo.email)) {
      return "Invalid email format.";
    }

    if (!/^\d{10}$/.test(candidateInfo.mobilenumber)) {
      return "Mobile number must be 10 digits.";
    }

    return null;
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    const error = validateForm();
    if (error) {
      setMessage(error);
      setShowMessage(true);
      return;
    }

    const formData = new FormData();
    Object.entries(candidateInfo).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("domain", domain);
    formData.append("resume", cv);

    try {
      setLoading(true);
      setShowMessage(false);

      const res = await axios.post(
        "https://iqapexlabs.onrender.com/api/candidate",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setMessage(res?.data?.message || "Application submitted successfully!");
      setShowMessage(true);
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      setShowMessage(true);
    } finally {
      setLoading(false);
      setTimeout(() => setShowMessage(false), 5000);
    }
  };

  return (
    <section className={classes.wrapper}>
      <h1>Job Application Form</h1>

      <form
        className={classes.jobApplyForm}
        onSubmit={onSubmitHandler}
        noValidate
      >
        {/* Full Name */}
        <div className={classes.inputField}>
          <label htmlFor="fullname">
            Full Name <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="text"
            id="fullname"
            name="fullname"
            value={candidateInfo.fullname}
            onChange={onFieldChange}
            required
          />
        </div>

        {/* Email */}
        <div className={classes.inputField}>
          <label htmlFor="email">
            Email <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={candidateInfo.email}
            onChange={onFieldChange}
            required
          />
        </div>

        {/* Mobile */}
        <div className={classes.inputField}>
          <label htmlFor="mobilenumber">
            Mobile Number <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="tel"
            id="mobilenumber"
            name="mobilenumber"
            value={candidateInfo.mobilenumber}
            onChange={onFieldChange}
            required
          />
        </div>

        {/* College */}
        <div className={classes.inputField}>
          <label htmlFor="college">
            College Name <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="text"
            id="college"
            name="college"
            value={candidateInfo.college}
            onChange={onFieldChange}
            required
          />
        </div>

        {/* Passout */}
        <div className={classes.inputField}>
          <label htmlFor="passout">
            Passout Year <span className={classes.asterisk}>*</span>
          </label>
          <select
            id="passout"
            name="passout"
            value={candidateInfo.passout}
            onChange={onFieldChange}
            required
          >
            <option value="" disabled>
              ----
            </option>
            {yearArr.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Address */}
        <div className={classes.inputField}>
          <label htmlFor="address">
            Current Address <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="text"
            id="address"
            name="address"
            value={candidateInfo.address}
            onChange={onFieldChange}
            required
          />
        </div>

        {/* Domain */}
        <div className={classes.inputField}>
          <label>Applied For</label>
          <input type="text" value={domain} disabled />
        </div>

        {/* Github */}
        <div className={classes.inputField}>
          <label htmlFor="github">Github URL</label>
          <input
            type="url"
            id="github"
            name="github"
            value={candidateInfo.github}
            onChange={onFieldChange}
          />
        </div>

        {/* LinkedIn */}
        <div className={classes.inputField}>
          <label htmlFor="linkedin">LinkedIn URL</label>
          <input
            type="url"
            id="linkedin"
            name="linkedin"
            value={candidateInfo.linkedin}
            onChange={onFieldChange}
          />
        </div>

        {/* Resume */}
        <div className={classes.inputField}>
          <label htmlFor="resume">
            Upload Resume <span className={classes.asterisk}>*</span>
          </label>
          <input
            type="file"
            id="resume"
            accept=".pdf,.doc,.docx"
            onChange={(e) => setCV(e.target.files[0])}
            required
          />
        </div>

        {/* Submit */}
        <button
          type="submit"
          className={classes.btn}
          disabled={loading}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        >
          {loading ? "Submitting..." : "Submit Application"}
        </button>

        {showMessage && (
          <p
            className={
              message.toLowerCase().includes("success")
                ? classes.success
                : classes.error
            }
            role="alert"
          >
            {message}
          </p>
        )}
      </form>
    </section>
  );
};

export default CareerForm;
